import {useEffect, useState} from 'react'
import {Navigate, Routes} from 'react-router-dom'
import {useAuth} from './core/Auth'

export function Logout() {
  const {logout} = useAuth()
  const [wasBlocked, setWasBlocked] = useState(false)

  useEffect(() => {
    const didLogout = logout()
    if (!didLogout) {
      setWasBlocked(true)
      return
    }
    document.location.reload()
  }, [logout])

  if (wasBlocked) {
    return <Navigate to='/dashboard' replace />
  }

  return (
    <Routes>
      <Navigate to='/auth/login' />
    </Routes>
  )
}
